import React from 'react'
import "./OurLeadership.css"

const OurLeadership = () => {
  return (
    <div className='leadership pb-5'>
        <div className="mt-5 text-center">
            <span className='mb-4'>
                <b>Our Leadership</b>
            </span>
            <div class="serverd">
                Not to be served, but to serve!
            </div>
        </div>
    </div>
  )
}

export default OurLeadership